/** Brand tied to `UniqueCode.codeBrand` — drives background + questionnaire set. */
export type CodeBrand = 'Dice' | 'LBS';

export const CODE_BRANDS: readonly CodeBrand[] = ['Dice', 'LBS'] as const;

/** Normalize DB / API value; unknown or empty → Dice. */
export function normalizeCodeBrand(raw: string | null | undefined): CodeBrand {
  const v = (raw ?? '').trim().toLowerCase();
  if (v === 'lbs') return 'LBS';
  return 'Dice';
}

export function isCodeBrand(value: string | null | undefined): value is CodeBrand {
  return value === 'Dice' || value === 'LBS';
}

/** Full-bleed survey background by brand (Tailwind needs these literal URLs). */
export function surveyBackgroundImageUrl(brand: CodeBrand | null | undefined): string {
  return brand === 'LBS' ? '/images/LBS_bg.jpg' : '/images/Dice_bg.jpg';
}

/**
 * First questionnaire route after OTP verify.
 * Both LBS and Dice start at `/smokerprofile`; brand BG + question sets diverge from there.
 */
export function surveyPathAfterOtp(_brand?: CodeBrand | null): string {
  return '/smokerprofile';
}

/** After otherbrands both brands continue at `/7_1` (brand-specific options from there). */
export function surveyPathAfterOtherBrands(_brand?: CodeBrand | null): string {
  return '/7_1';
}
